export default {
  /**
   * 授权
   */
  auth: "/api/v1.0/wechat/authorize",

  /**
   * 领券
   */
  rcoupons: "/api/v1.0/wechat/depositCardCoupons",

  /**
   * 批量绑定实体卡
   */
  batchCoupons: "/api/v1.0/wechat/depositCardCoupons/batch",

  /**
   * 查券
   */
  qcoupons: "/api/v1.0/wechat/user/coupons",

  /**
   * 获取用户信息
   */
  user: "/api/v1.0/auto-login",

  /**
   * 注册
   */
  register: "/api/v1.0/wechat/bindMobile",

  /**
   * 获取验证码
   */
  getCode: "api/v1.0/wechat/captcha/",

  /**
   * 查询服务
   */
  getServer: "/api/v1.0/categories/coupons/",

  /**
   * 查询服务可用券
   */
  getService: "/api/v1.0/coupons/categories/getValidCoupons",

  /**
   * 下单
   */
  sumitOrder: "/api/v1.0/user/online/order",

  /**
   * 查询话费流量服务商
   */
  mobileServe: "/api/v1.0/user/online/operator",

  /**
   * 查询服务面值
   */
  getProductList: "/api/v1.0/user/online/products",

  /**
   * 查询油卡列表
   */
  getOilCardList: "api/v1.0/wechat/oilCard/getOilCardList",

  /**
   * 添加修改油卡
   */
  addUpdateOilCard: "api/v1.0/wechat/oilCard/",

  /**
   * 获取订单
   */
  getOrders: "/api/v1.0/wechat/orders",

  /**
   * 获取已用礼券
   */
  getUsedCoupons: "/api/v1.0/wechat/usedCoupons",

  /**
   * 再次支付
   */
  repay: "/api/v1.0/user/online/wechat/repay/",

  /**
   * 取消订单
   */
  cancelOrder: "/api/v1.0/user/online/orders/",

  /**
   * 设置默认油卡
   */
  setDefaultCard: "/api/v1.0/wechat/oilCard/default/",

  /**
   * 获取转让卡券链接
   */
  transCardUrl: "/api/v1.0/wechat/recovery/getCardInfo",

  /**
   * 获取服务电话号码
   */
  getServerPhone: "/api/v1.0/user/online/service-hotline",

  /**
   * 获取卡券批量转让信息
   */
  batchTransCardUrl: "/api/v1.0/wechat/recovery/batchGetCardInfo",

  /**
   * 获取卡券批量转让url
   */
  batchRecoveryUrl: "/api/v1.0/wechat/recovery/batch/url",

  /**
   * 获取公众号用于调用微信JS接口的临时票据
   */
  getticket: "/api/v1.0/wechat/wechat-js-config",

  /**
   * 获取卡券转让首页链接
   */
  recoveryHomeUrl: "/api/v1.0/wechat/recovery/getHomeUrl",

  /**
   * 校验验证码
   */
  checkCode: "api/v1.0/wechat/updateMobile/checkCaptcha/",

  /**
   * 根据手机号查询短信发券信息
   */
  couponsByMobile: "/api/v1.0/wechat/coupons/byMobile",

  /**
   * 获取洗车门店列表
   */
  getStoreList: "/api/v1.0/car/wash/shops",

  /**
   * 卡券购买
   */
  couponExchange: "/api/v1.0/user/online/coupon/exchange",

  /**
   * 获取卡券核销码
   */
  getCouponVerifyCode: "/api/v1.0/car/wash/codes",

  /**
   * 查询单张卡券
   */
  queryCoupon: "/api/v1.0/coupons/coupon",

  /**
   * 获取核销卡券数量
   */
  getVerifyCouponsCount: "/api/v1.0/wechat/verify/coupons/count",

  /**
   * 获取年审检测站列表
   */
  getDecetionList: "/api/v1.0/car/annual-verification/quote",
  /**
   * 上线年审下单
   */
  annualVerificationOrder: "/api/v1.0/car/annual-verification/orders",

  /**
   * 获取代驾券核销地址
   */
  getDrivingCodeUrl: "/api/v1.0/car/drives/codes",

  /**
   * 购物卡购买
   */
  buyShoppingCard: "/api/v1.0/user/online/coupon/jd-ecard",

  /**
   * 视频购买
   */
  buyVideo: "/api/v1.0/user/online/coupon/videoOrder",

  /**
   * 获取视频订单信息
   */
  getVideoOrder: "/api/v1.0/order/video/getInfo",

  /**
   * 获取卡密信息
   */
  getCardPwdInfo: "/api/v1.0/wechat/cardPwdOrder/getInfo",

  /**
   * 查询用户退保支付金额
   */
  getCancelInsuranceAmount: "/api/v1.0/user/online/insurance/cancel/amount",
  
  getCancelInsuranceInfo: "/api/v1.0/user/online/insurance/cancel/info",

  /**
   * 获取用户待支付订单数量
   */
  getUserWaitPayOrdersCount: "/api/v1.0/wechat/surrenderOrder/waitPay/count",
  /**
   * 获取提现默认账号
   */
  defaultAccountURL: '/api/v1.0/withdraw/account/default',
    /**
   * 查询银行卡列表
   */
  getBankList: "api/v1.0/wechat/bank/getBankList",
   /**
   * 支付宝账号管理
   */
  alipayAccountURL: '/api/v1.0/withdraw/account/alipay',
    /**
   * 银行卡账号管理
   */
  bankAccountURL: '/api/v1.0/withdraw/account/bank',
    /**
   * 删除提现账号
   */
  deleteAccountURL: '/api/v1.0/withdraw/account',
    /**
   * 提现
   */
  withdraw: "/api/v1.0/wechat/user/coupons/withdraw",
   /**
   * 微信账号管理
   */
  wxpayAccountURL: '/api/v1.0/withdraw/account/wxpay',
  /**
   * 获取订单
   */
  getWithdraw: "/api/v1.0/wechat/withdraws",
};
